import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-esports-hda',
    templateUrl: './default/esports-hda/esports-hda.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class EsportsHdaComponent extends UnitsDistributionBase {
  // Used for ESPORTS_HDA
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}